export default {
  heading: 'contact us',
  subheading: 'Fill out the form below, send a message to hola at mikmak dot tv, or give us a ring at 1-844-645-6251',
  successMessage: 'Thanks for the message. We\'ll be in touch shortly!',
  formFields: [
    {
      className: 'footer-bar-contact-form-text',
      type: 'text',
      name: 'name',
      placeholder: 'your name',
      required: true
    },
    {
      className: 'footer-bar-contact-form-text',
      type: 'email',
      name: 'email',
      placeholder: 'your email',
      required: true
    },
    {
      className: 'footer-bar-contact-form-text',
      type: 'text',
      name: 'company',
      placeholder: 'company',
      required: false
    },
    {
      className: 'footer-bar-contact-form-text',
      type: 'text',
      name: 'message',
      placeholder: 'your message',
      required: false
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/imports/Contact.js